import React from 'react';
import { Paper, Typography, Button } from '@mui/material';
import { Add, Assessment } from '@mui/icons-material';

interface EmptyAnalysisStateProps {
  searchTerm: string;
  onAddAnalysis: () => void;
}

const EmptyAnalysisState: React.FC<EmptyAnalysisStateProps> = ({ searchTerm, onAddAnalysis }) => {
  return (
    <Paper sx={{ p: 6, textAlign: 'center' }}>
      <Assessment sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" color="text.secondary" gutterBottom>
        {searchTerm ? 'No analyses found' : 'No analyses yet'}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {searchTerm
          ? 'Try adjusting your search terms'
          : 'Start by running your first product authenticity analysis'
        }
      </Typography>
      {!searchTerm && (
        <Button
          variant="contained"
          size="large"
          startIcon={<Add />}
          onClick={onAddAnalysis}
        >
          Run First Analysis
        </Button>
      )}
    </Paper>
  );
};

export default EmptyAnalysisState;